import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Chip,
  Avatar,
} from "@mui/material";
import FootBallImg from "../../../assets/customerAssets/football.png";
import GoalModal from "../../Modals/user/goalModal/LeagueGoal";

const getTime = (duration) => {
  let temp = duration;
  if (!temp) {
    return `0:00`;
  }
  if (duration > 60) {
    let min = 0;
    let sec = 0;
    min = Math.floor(temp / 60);
    sec = temp % 60;
    return `${min}:${sec}`;
  } else if (temp == 60) {
    return `1:00`;
  } else {
    return `0:${temp}`;
  }
};

const VideoComoponent = ({ img, duration, data, setTournamentData }) => {
  const [open, setOpen] = useState(false);
  const [voteState, setVoteState] = useState(data?.voteCount);

  useEffect(() => {
    setTournamentData((tdata) => {
      const newGoals = tdata?.leagueGoals?.map((gdata) =>
        gdata.id == data.id
          ? { ...gdata, voteCount: voteState, hasVoted: 1 }
          : gdata,
      );
      const rankedGoals = newGoals?.sort((a, b) =>
        a.voteCount > b.voteCount ? -1 : 1,
      );
      return { ...tdata, leagueGoals: rankedGoals };
    });
  }, [voteState]);

  return (
    <>
      <Box
        className="img_div"
        sx={img ? {} : { backgroundColor: "white", opacity: 0.6 }}
        onClick={() => setOpen(true)}
      >
        <img
          src={img ? img : FootBallImg}
          alt="video"
          className="img_fluid"
          style={img ? { objectFit: "cover" } : { objectFit: "contain" }}
        />

        <Box className="duration">{getTime(duration)}</Box>
      </Box>
      <GoalModal
        goalId={data?.id}
        setCount={setVoteState}
        count={voteState}
        open={open}
        setOpen={setOpen}
        data={data}
      />
    </>
  );
};

export default VideoComoponent;
